import { useEffect } from 'react'
import { useAuthStore } from '@/stores/auth.store'
import { resumeKmRendersFromServer } from '@/lib/kmRenderPoll'

/** After F5: restore in-progress KM renders from backend, not sessionStorage. */
export function useKmRenderResume() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated)
  const role = useAuthStore((s) => s.role)
  const permissionsConfigured = useAuthStore((s) => s.permissionsConfigured)
  const effectiveEndpoints = useAuthStore((s) => s.effectiveEndpoints)

  useEffect(() => {
    if (!isAuthenticated || role !== 'admin') return
    if (permissionsConfigured && !effectiveEndpoints?.includes('tasks')) return
    void resumeKmRendersFromServer()
  }, [isAuthenticated, role, permissionsConfigured, effectiveEndpoints])
}
